import "./AbilityRow.css";
import { formatMod, getAbilityDisplayName } from "../../../pages/Characters/characterHelpers";
import UiButton from "../../Buttons/UiButton";
import { Colors } from "../../../models/enums";

type AbilityRowProps = {
    name: string;
    score: number;
    mod: number;

    pointBuyCost: number;

    canDec: boolean;
    canInc: boolean;
    onDec: () => void;
    onInc: () => void;
};

function AbilityRow(props: AbilityRowProps): JSX.Element {
    const { name, score, mod, pointBuyCost, canDec, canInc, onDec, onInc } = props;

    const displayName = getAbilityDisplayName(name);
    const isNegative = mod < 0;
    const leftStyle: React.CSSProperties = {
        background: isNegative ? Colors.uiAbilityRowNegative : Colors.uiAbilityRowPositive,
    };

    return (
        <div className="abilityRow">
            <div className={`abilityRow-left ${isNegative ? "isNegative" : "isPositive"}`} style={leftStyle} >
                <div className="abilityRow-name">{displayName.toUpperCase()}</div>

                <div className="abilityRow-scoreBlock">
                    <div className="abilityRow-score">{score}</div>
                    <div className="abilityRow-mod">({formatMod(mod)})</div>
                </div>
            </div>

            <div className="abilityRow-right">
                <div className="abilityRow-stepBtn">
                    <UiButton
                        variant="sage"
                        text="+"
                        width="44px"
                        onClickCallback={onInc}
                        disabled={!canInc}
                    />
                </div>

                <div className="abilityRow-cost">{pointBuyCost}</div>

                <div className="abilityRow-stepBtn">
                    <UiButton
                        variant="brown"
                        text="-"
                        width="44px"
                        onClickCallback={onDec}
                        disabled={!canDec}
                    />
                </div>
            </div>
        </div>
    );
}

export default AbilityRow;
